
  <div class="modal-warn-message">
    <div class="modal-warn-message__content">
      <div class="customheader">
        <div class="blankbase customheader__blank"></div>
          <div class="customheader__iconwrap">
            <div class="customheader__iconwrap__container">
              <div class="customheader__iconwrap__container__icon">
                <img [src]="logo" alt="..." />
              </div>
            </div>
          </div>
          <div class="blankbase customheader__blankrest">
            <span class="customheader__blankrest__text-close" (click)="outBackdrop.emit(); close()">Cerrar</span>
            <em
              class="far fa-times"
              (click)="outBackdrop.emit(); close()"></em>
          </div>
      </div>
      <div class="modal-warn-message__span" *ngIf="isValue === 1 || isValue === 3 || isValue === 4 && isAgent">
        <span class="fas fa-circle-xmark user-gears-icon"></span>
      </div>
      <div class="modal-warn-message__span" *ngIf="isValue === 2">
        <span class="fas fa-users-gear user-gears-icon"></span>
      </div>     
      <h4 class="modal-warn-message-header" *ngIf="isValue === 1 || isValue === 3 || isValue === 4 && isAgent">Tu perfil no aplica para comprar este plan.</h4>
      <h4 class="modal-warn-message-header" *ngIf="isValue === 2">Ajusta tu tipo de usuario</h4>
      <p class="modal-warn-message-body" *ngIf="isValue === 1 || isValue === 3 || isValue === 4 && isAgent">{{textMessageModal}}</p>
      <p class="modal-warn-message-body" *ngIf="isValue === 2">{{textMessageModalAgent}}</p>
      <div class="modal-warn-message-button" *ngIf="isValue === 1 && isPerson || isValue === 3 && isPerson">
        <div class="modal-warn-message-btn">
          <a class="btn-change-user-modal ccbutton button undefined secondary rounded" [href]="urlPublicaTuMismo">Entendido</a>
        </div>
      </div>
      <div class="modal-warn-message-button" *ngIf="isValue === 1 && isAgent || 3 && isAgent || 4 && isAgent">
        <div class="modal-warn-message-btn">
          <a class="btn-change-user-modal ccbutton button undefined secondary rounded" [href]="urlSelectionIdeal">Entendido</a>
        </div>
      </div>
      <div class="modal-warn-message-button" *ngIf="isValue === 2">
        <div class="modal-warn-message-btn">
          <a class="btn-accept-modal" [href]="urlPublicaTuMismo">Ver planes propietarios</a>
        </div>
        <div class="modal-warn-message-btn">
          <a class="btn-change-user-modal ccbutton button undefined secondary rounded" (click)="userTypeChange()">Sí, cambiar usuario</a>
        </div>
      </div>
    </div>
  </div>

